import React, { Component } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import RecentCase from 'Components/RecentCase/RecentCase';
import { removeCaseFromRecent } from 'Actions/recentCasesAction.js';
import CaseIcon from 'Components/icons/CaseIcon/CaseIcon';
import counterpart from 'counterpart';
import CloseCaseIcon from 'Components/icons/CloseCaseIcon';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import './RecentCaseView.scss';
import { VITE_RECENT_CASE_LIMIT } from 'Constants/appEnvConstants';

class RecentCaseView extends Component {
  constructor(props) {
    super(props);
    this.removeRecentCase = this.removeRecentCase.bind(this);
    this.removeAllRecentCases = this.removeAllRecentCases.bind(this);
  }

  componentDidMount() {
    document.getElementById('case-body').scrollTop = 0;
  }

  componentWillReceiveProps() {
    document.getElementById('case-body').scrollTop = 0;
  }

  removeRecentCase(caseNumberToRemove) {
    if (this.props.unlockCurrentCase) {
      this.props.unlockCurrentCase(caseNumberToRemove);
    } else {
      this.props.removeCaseFromRecent(caseNumberToRemove);
    }
  }

  removeAllRecentCases(casesToBeRemoved) {
    if (casesToBeRemoved.length > 0) {
      this.props.unlockAllCurrentCases(casesToBeRemoved);
    }
  }

  render() {
    const acquirerCode = JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode;
    return (
      <div className="recent-cases-wrapper">
        <div className={`recent-case-title ${this.props.recentCasesList?.length > 0 ? 'with-cases' : ''} title` + acquirerCode}>
          <CaseIcon />
          <h4>{counterpart('globalTranslate.navigation.openCases').replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase())}</h4>
          {this.props.recentCasesList?.length > 0 ?
            <div
              className={'recent-case-close-all'}
              role="button"
              onClick={() => this.removeAllRecentCases(this.props.recentCasesList)}
            >
              <InformationBubble
                tooltipContent={"Close All"}
                id={"recentCases"}>
                <CloseCaseIcon />
              </InformationBubble>
            </div> : <div></div>}
        </div>
        <div id="case-body" className="recent-cases-body">
          {this.props.recentCasesList?.length > 0 && this.props.recentCasesList.map((list, index) => {
            const recentCase =
              this.props.recentCasesList[this.props.recentCasesList.length - 1 - index].caseNumber ?
                this.props.recentCasesList[this.props.recentCasesList.length - 1 - index].caseNumber :
                this.props.recentCasesList[this.props.recentCasesList.length - 1 - index];
            return VITE_RECENT_CASE_LIMIT > index && (
              <RecentCase
                key={index}
                caseNumber={recentCase}
                route={`/caselanding/${recentCase}`}
                navActionClasses="recent-case-action"
                activeClassName="recent-case-action recent-case-action-active"
                labelClasses="recent-case-label"
                removeRecentCase={this.removeRecentCase}
                navLabel={recentCase}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

RecentCaseView.propTypes = {
  extraClass: PropTypes.string,
  recentCasesList: PropTypes.array.isRequired,
  removeCaseFromRecent: PropTypes.func,
};

RecentCaseView.defaultProps = {
  extraClass: '',
  removeCaseFromRecent: () => { }
};

function mapDispatchToProps(dispatch) {
  return {
    removeCaseFromRecent: (caseNumberToRemove) => {
      dispatch(removeCaseFromRecent(caseNumberToRemove));
    }
  };
}

export default connect(undefined, mapDispatchToProps)(RecentCaseView);
